import React, { useState, useEffect } from 'react'
// import { mainStyles, theme } from '../../styles'
import { useDispatch, useSelector } from "react-redux"//Hooks de redux
import { useNavigate, useLocation } from 'react-router-dom'//React routes
import {
    Typography, Box, styled, useTheme
} from '@mui/material'//Se importan elementos de la librería material-ui
import useSwiper from "use-swiper"
import "use-swiper/lib/swiper.min.css"
import { makeStyles } from '@mui/styles'

import { fileActions } from '../../store/actions/FileActions.js'
import { useStyles } from './EvidenceStyles'
// import { evidenceFunctions } from './EvidenceFunctions'
import { UseImage, CustomLoadingOverlay, Buttons, GenericDialog, GenericContainerForm } from '../../components'
import help_videopol_01Img from '../../assets/help_videopol_01.gif'
import help_videopol_03Img from '../../assets/help_videopol_03.gif'
import help_videopol_04Img from '../../assets/help_videopol_04.gif'
import help_videopol_05Img from '../../assets/help_videopol_05.gif'
import help_videopol_05ImgBR from '../../assets/help_videopol_05_BR.gif'
import { coreFunctions, IsDevice } from '../../utils';
import { useTranslation } from 'react-i18next';

const ContainerImagePIN = styled(Box)(({ theme }) => ({
    width: '100%',
    display: 'flex',
    alignContent: 'center',
    alignItems: 'center',
    overflow: 'hidden',
    textAlign: 'center',
    justifyContent: 'center',
    [theme.breakpoints.only('xs')]: {
        height: '35vh',
    },
    [theme.breakpoints.only('sm')]: {
        height: '40vh',
    },
    [theme.breakpoints.only('md')]: {
        height: '45vh',
    },
    [theme.breakpoints.only('lg')]: {
        height: '50vh',
    },
    [theme.breakpoints.only('xl')]: {
        height: '55vh',
    },
}));

export default function Evidence(props) {

    const { ref } = useSwiper({
        pagination: true,
        loop: true,
    })

    const theme = useTheme()
    const location = useLocation()
    const classes = {} //mainStyles.bodyStyles()//estílos genéricos (Main.js)
    const localStyles = useStyles()
    const navigate = useNavigate()

    const [openHelpDialog, setOpenHelpDialog] = useState(true)//Se muestra/oculta el gif loader
    const [currentStage, setCurrentStage] = useState(0)
    const [stageProps, setStageProps] = useState(0)
    const [totalStage, setTotalStage] = useState(0);
    const { t, i18n } = useTranslation();
    const lang = i18n.language || "es";

    const [loadView, setLoadView] = useState(false)//Se muestra/oculta el gif loader 

    const [activeAudioEvidence, setActiveAudioEvidence] = useState("0")
    const [activeVideoEvidence, setActiveVideoEvidence] = useState("0")

    const dispatch = useDispatch()

    //Redux hooks
    const auth = useSelector(state => state.Authentication)
    const wf = useSelector(state => state.Workflow)
    const file = useSelector((state) => state.FileInfo);

    useEffect(() => {
        dispatch(fileActions.GetFileInfo(location.state.folioId));
        setLoadView(true)
        // if (stageProps != 0) {
        //     setCurrentStage(stageProps.CurrentStageGroup)
        //     setTotalStage(stageProps.TotalStageGroups)
        // }
    }, [])

    useEffect(() => {
        if (file.items != undefined && loadView) {
            setLoadView(false)
            setCurrentStage(stageProps.CurrentStageGroup)
            setTotalStage(stageProps.TotalStageGroups)
            console.log("file.items:---------Stage-----------: ", file.items.Stage)

            let actAudioEvidence = file.items.Stage.Properties.find(element => element.Name == "ActiveAudioEvidence")
            let actVideoEvidence = file.items.Stage.Properties.find(element => element.Name == "ActiveVideoEvidence")
            let activeGeolocation = file.items.Stage.Properties.find(element => element.Name == "ActiveGeolocation")

            console.log("propiedades: ", actAudioEvidence, actVideoEvidence, activeGeolocation)

            if (actAudioEvidence?.Value == "0" && actVideoEvidence?.Value == "0" && activeGeolocation?.Value == "1") {
                let stageName = file.items.Stage.Name
                let stageId = file.items.Stage.Id
                let stage = file.items.Stage
                let folioId = file.items.Id

                let nextComponent = "LocationEAudioComponent"
                coreFunctions.DoNextStage({ navigate, nextComponent, State: { stageName, stageId, stage, folioId } })
            }
            else if (actAudioEvidence?.Value == "0" && actVideoEvidence?.Value == "0") {
                let folioId = file.items.Id
                let audiob64 = null
                let textAudio = ""
                let textVideo = ""
                let dateEvidence = ""
                let nextComponent = "LocationEAudioComponent"
                console.log("nextComponent-------: ", nextComponent, folioId, audiob64, textAudio, textVideo, dateEvidence)
                coreFunctions.DoNextStage({ navigate, nextComponent, State: { folioId, audiob64, textAudio, textVideo, dateEvidence } })
            }
            else {
                setActiveAudioEvidence(actAudioEvidence?.Value)
                setActiveVideoEvidence(actVideoEvidence?.Value)
            }
        }
    }, [file])

    let submitForm = (e) => {//Submit del form de stage dinámico (validaciones)
        e.preventDefault()

        console.log("activeAudioEvidence-----------------: ", activeAudioEvidence, activeVideoEvidence)
        let nextComponent = ""
        if (activeAudioEvidence == "1") {
            //console.log("entro activeAudioEvidence")
            let stageName = file.items.Stage.Name
            let stageId = file.items.Stage.Id
            let stage = file.items.Stage
            let folioId = file.items.Id

            nextComponent = "EvidenceAudioComponent"
            coreFunctions.DoNextStage({ navigate, nextComponent, State: { stageName, stageId, stage, folioId } })
        } else if (activeVideoEvidence == "1") {
            let stageName = file.items.Stage.Name
            let stageId = file.items.Stage.Id
            let stage = file.items.Stage
            let folioId = file.items.Id

            nextComponent = "EvidenceStartComponent"
            coreFunctions.DoNextStage({ navigate, nextComponent, State: { stageName, stageId, stage, folioId } })
        }
        else if (activeAudioEvidence == "0" && activeVideoEvidence == "0") {
            // console.log("handlerContinue--- Aceptar--- ", "record.wav", dataAudio)
            // console.log("handlerContinue--- Aceptar--- b64 ", datab64)
            let folioId = file.items.Id
            let audiob64 = null
            // let audiob64 = dataBlob
            let textAudio = ""
            let textVideo = ""
            let dateEvidence = ""
            let nextComponent = "LocationEAudioComponent"
            console.log("nextComponent-------: ", nextComponent, folioId, audiob64, textAudio, textVideo, dateEvidence)
            coreFunctions.DoNextStage({ navigate, nextComponent, State: { folioId, audiob64, textAudio, textVideo, dateEvidence } })
        }

        // let nextComponent = "EvidenceComponent"
        // let stageName = file.items.Stage.Name
        // let stageId = file.items.Stage.Id
        // let stage = file.items.Stage
        // let folioId = file.items.Id

        // evidenceFunctions.doNextStage({ auth ,navigate,nextComponent, stageName, stageId, stage, folioId })
    }

    return (<GenericDialog open={openHelpDialog} onClose={!openHelpDialog} viewMenu={true} viewButtonClose={false}
        // title="Evidencia - Ubicación"
        content={<Box sx={{
            display: 'flex',
            position: 'relative',
            flexDirection: 'column',
            alignItems: "center",
        }}>
            <GenericContainerForm sx={(theme) => ({
                width: "80%", [theme.breakpoints.only('xs')]: {
                    width: "100%"
                }
            })}>
                <CustomLoadingOverlay active={loadView} text={t("general_loading_message")} />
                {IsDevice().IsMobile ?
                    <div ref={ref} className={localStyles.wizardContainer}>
                        {/* <div key={1} >
                        <div className={localStyles.carouselSection}>
                            <div className={localStyles.textContent}>
                                <Typography variant="subtitle1" gutterBottom >Sigue las siguientes instrucciones para realizar la videograbación.</Typography>
                                <Typography variant="subtitle1" gutterBottom >1. Toma tu dispositivo móvil y colócalo de forma horizontal.</Typography>
                            </div>
                            <UseImage
                                className={localStyles.helpImage}
                                src={help_videopol_01Img}
                            />
                        </div>
                    </div> */}
                        <div key={1} >
                            <div className={localStyles.carouselSection}>
                                <div className={localStyles.textContent}>
                                    <Typography variant="subtitle1" gutterBottom>{t("face_uncovered")}</Typography>
                                </div>
                                <UseImage
                                    className={localStyles.helpImage}
                                    src={help_videopol_03Img}
                                />
                            </div>
                        </div>
                        <div key={2} >
                            <div className={localStyles.carouselSection}>
                                <div className={localStyles.textContent}>
                                    <Typography variant="subtitle1" gutterBottom>{t("read_text_aloud")}</Typography>
                                </div>
                                <UseImage
                                    className={localStyles.helpImage}
                                    src={help_videopol_04Img}
                                />
                            </div>
                        </div>
                    </div>
                    :
                    <Box sx={{
                        display: "flex",
                        flexDirection: "column",
                    }} >
                        <Typography
                          variant="subtitle1"
                          gutterBottom
                        >
                          {t("applicant_video_message")}
                        </Typography>
                        <ContainerImagePIN>
                            <UseImage
                                className={localStyles.helpImage1}
                                src={lang === "pt" ? help_videopol_05ImgBR : help_videopol_05Img}
                            />
                        </ContainerImagePIN>
                    </Box>
                }
            </GenericContainerForm>
            <Buttons
                ConfirmButtonText={t("applicant_start_recording")}
                type='button'
                onClickConfirm={submitForm} />

        </Box>}
    />)
}